export type Partner = {
  srcL: string
  srcD: string
  // Dimensions naturelles du fichier (identiques en version claire et foncée) : évitent un décalage au chargement.
  width: number
  height: number
  alt: string
  category: string
  description?: string
  // Logos compacts ou empilés : affichés plus grands pour rester lisibles.
  large?: boolean
}

// Partenaires et clients affichés dans « Ils nous font confiance » et sur la page /partenaires.
export const PARTNERS: Partner[] = [
  {
    srcL: '/images/about/partners/domeb.png',
    srcD: '/images/about/partners/domew.png',
    width: 163,
    height: 48,
    alt: 'Le Dôme de Charleroi',
    category: 'Lieu événementiel',
  },
  {
    srcL: '/images/about/partners/stpb.png',
    srcD: '/images/about/partners/stpw.png',
    width: 340,
    height: 200,
    alt: 'Sport & Tourism Promotion',
    category: 'Événements sportifs',
    large: true,
  },
  {
    srcL: '/images/about/partners/illepsb.png',
    srcD: '/images/about/partners/illepsw.png',
    width: 318,
    height: 320,
    alt: 'ILLEPS - Institut Libre Luxembourgeois de Promotion Sociale',
    category: 'Formation',
    large: true,
    description: 'Partenaire de la formation ATNUP organisée à Virton.',
  },
  {
    srcL: '/images/about/partners/obmb.png',
    srcD: '/images/about/partners/obmw.png',
    width: 396,
    height: 48,
    alt: 'Oberbayern',
    category: 'Événementiel',
  },
  {
    srcL: '/images/about/partners/urbanb.png',
    srcD: '/images/about/partners/urbanw.png',
    width: 338,
    height: 160,
    alt: 'Urban Heroes Challenge',
    category: 'Événements sportifs',
    large: true,
  },
]
